module.exports = __webpack_public_path__ + "assets/img/iOS.6da5a488.svg";